import { removeFrom, UserDetails } from "@vrf/fr-vrf-core";
import { ENV } from "./env-util";

const ENABLE_DEV_LOGIN = ENV("REACT_APP_ENABLE_DEV_LOGIN") === "true";
const LOCAL_STORAGE_KEY_USER_DETAILS = "user-details";

const hasRole = (role: string, user?: UserDetails): boolean => {
  if (!user) return false;
  if (user.assignedRoleCodeList?.some((e) => e.id === role)) {
    return true;
  }
  return false;
};

export const isProperUser = (user?: UserDetails): boolean => {
  if (ENABLE_DEV_LOGIN) return true;
  if (hasRole("JDI_ONLINE_APP_JDI_PROPER", user)) {
    return true;
  }
  return false;
};

export const isGuestUser = (user?: UserDetails): boolean => {
  if (ENABLE_DEV_LOGIN) return false;
  if (hasRole("JDI_ONLINE_APP_JDI_GUEST", user)) {
    return true;
  }
  return false;
};

export const removeUserDetails = () => {
  removeFrom("local", LOCAL_STORAGE_KEY_USER_DETAILS);
};
